import React, { useState, useEffect, useContext, useRef } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import { Collapse } from 'antd';

const BoxplotChart = (props) => {
    const { Panel } = Collapse;

    let boxplotData = props.getAnalysisRes.boxplot;
    let boxplotDisplayName = props.getAnalysisRes.display_name;
    let boxplotXAxis = props.getAnalysisRes.statistics_by_variable;
    let boxplotCategories = Object.keys(boxplotData);
    let boxplotSeriesData = []
    let boxplotOutliers = [];

    boxplotCategories.forEach((category) => {
        boxplotSeriesData.push([
            boxplotData[category].low_whisker,
            boxplotData[category].lower_quartile,
            boxplotData[category].median,
            boxplotData[category].upper_quartile,
            boxplotData[category].high_whisker
        ]);
        // list of outliers for each category [x, y] where x is the category index from 0 and y is the outlier value
        boxplotData[category].high_outlier.forEach((outlier) => {
            boxplotOutliers.push([boxplotCategories.indexOf(category), outlier]);
        });
        boxplotData[category].low_outlier.forEach((outlier) => {
            boxplotOutliers.push([boxplotCategories.indexOf(category), outlier]);
        });

    });
    // console.log(boxplotSeriesData)
    console.log(boxplotOutliers)

        // console.log(boxplotData)
    // const outlier = boxplotOutliers;

    let boxplotOptions = {
        credits: {
            enabled: false
        },
        chart: {
            type: 'boxplot',
            marginRight: 0,
            height: 400,
            renderTo: 'chart-container-1',
            events: {
                redraw: () => {}
            }
            // chartWidth: '100%'
            // marginLeft: 0,
        },
        boost: {
            useGPUTranslations: true,
            usePreAllocated: true
        },

        title: {
            text: ''
        },

        legend: {
            enabled: false
        },

        credits: { enabled: false, text: '' },

        xAxis: {
            categories: boxplotCategories, 
            title: {
                text: boxplotXAxis
            }
        },

        yAxis: {
            title: {
                text: boxplotDisplayName
            }
        },

        plotOptions: {
            series: {
                pointWidth: 200
            }
        },
        colors: ['#407cb1'],
        tooltip: {
            shared: true,
            useHTML: true,
            shape: 'square',
            borderRadius: 0,
            borderWidth: 0,
            shadow: false,
            enabled: true,
            backgroundColor: 'none',
            formatter: function () {
                if (this.points != undefined) {
                    var result =
                        '<div class="tooltipContainer">' +
                        'Count: ' +
                        boxplotData.count +
                        '<br>High Whisker: ' +
                        this.points[0].point.high +
                        '<br>Upper Quartile: ' +
                        this.points[0].point.q3 +
                        '<br>Median: ' +
                        this.points[0].point.median +
                        '<br>Lower Quartile: ' +
                        this.points[0].point.q1 +
                        '<br>Low Whisker: ' +
                        this.points[0].point.low +
                        '</div>';
                    return result;
                } else {
                    return (
                        '<div class="tooltipContainer">Outlier: ' +
                        this.point.y +
                        '</div>'
                    );
                }
            },
            positioner: function (boxWidth, boxHeight, point) {
                return { x: point.plotX - 50, y: 60 };
            }
        },
        series: [
            {
                name: 'Observations',
                data: boxplotSeriesData
            },
            {
                name: 'Outlier',
                color: '#60091d',
                type: 'scatter',
                data: boxplotOutliers,

                marker: {
                    fillColor: '#60091d',
                    // lineWidth: 1,
                    lineColor: '#60091d',
                    // radius: 1.3,
                    symbol: 'diamond'
                    // width: 60,
                    // height: 60
                },
                tooltip: {
                    pointFormat: 'Observation: {point.y}'
                }
            }
        ]
    };

    console.log(`NewBOX`);

    return (
        <>
            <Collapse bordered={false} defaultActiveKey={[1]}>
                <Panel key={1} header={`Boxplot [${boxplotDisplayName}] ${props.getAnalysisRes.filter_by_variable == null ? '': `[${props.getAnalysisRes.filter_by_variable}]`}`}>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={boxplotOptions}
                        ref={props.forwardedRef}
                    />
                </Panel>
            </Collapse>
        </>
    );
};

export default React.memo(BoxplotChart);
